// Bilder aus Word/Outlook-Zwischenablage: im HTML steht nur <img src="file:///…/clip_image001.png"> (lokale Temp-Datei,
// für den Browser unerreichbar). Die Bilddaten liegen parallel im RTF-Teil als {\pict … \pngblip <hex>}.
// In Dokument-Reihenfolge zuordnen – so macht es auch CKEditor (paste-from-office).

const LOCAL_IMAGE = /<img\b[^>]*?\bsrc\s*=\s*(["']?)((?:file:|cid:)[^"'\s>]*)\1[^>]*>/gi;

// {\pict …}-Gruppen ab Position start bis zur passenden schließenden Klammer
function groupEnd(rtf, start) {
    let depth = 0;
    for (let i = start; i < rtf.length; i++) {
        const char = rtf[i];
        if (char === '\\') {
            i++;
        } else if (char === '{') {
            depth++;
        } else if (char === '}') {
            depth--;
            if (depth === 0) {
                return i;
            }
        }
    }
    return -1;
}

export function extractRtfImages(rtf) {
    const images = [];
    if (!rtf) {
        return images;
    }
    const pattern = /\{\\pict\b/g;
    let match;
    while ((match = pattern.exec(rtf))) {
        const start = match.index;
        const end = groupEnd(rtf, start);
        if (end < 0) {
            break;
        }
        // \nonshppict ist die WMF-Ersatzdarstellung desselben Bildes für alte Leser
        const before = rtf.slice(Math.max(0, start - 40), start);
        let body = rtf.slice(start + 1, end);
        pattern.lastIndex = end;
        if (/\\nonshppict\s*$|\\nonshppict\s*\{?\s*$/.test(before)) {
            continue;
        }
        const type = /\\pngblip/.test(body) ? 'image/png' : (/\\jpegblip/.test(body) ? 'image/jpeg' : null);
        if (!type) {
            // WMF/EMF kann kein Mailprogramm anzeigen – Platz in der Reihenfolge trotzdem belegen
            images.push(null);
            continue;
        }
        // verschachtelte Gruppen ({\*\picprop …}, {\*\blipuid …}) und Steuerwörter entfernen → übrig bleibt Hex
        let previous;
        do {
            previous = body;
            body = body.replace(/\{[^{}]*\}/g, '');
        } while (body !== previous);
        const hex = body.replace(/\\[a-z]+-?\d*\s?/gi, '').replace(/[^0-9a-f]/gi, '');
        if (hex.length < 2) {
            images.push(null);
            continue;
        }
        images.push(`data:${type};base64,${hexToBase64(hex)}`);
    }
    return images;
}

function hexToBase64(hex) {
    let binary = '';
    for (let i = 0; i + 1 < hex.length; i += 2) {
        binary += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    }
    return btoa(binary);
}

export function countLocalImages(html) {
    return (html.match(LOCAL_IMAGE) || []).length;
}

// file:/cid:-Bilder der Reihe nach durch die gelieferten data:-URIs ersetzen; ohne Daten fliegt das Bild raus
export function resolveLocalImages(html, dataUris) {
    let index = 0;
    return html.replace(LOCAL_IMAGE, tag => {
        const dataUri = dataUris[index++];
        return dataUri ? tag.replace(/\bsrc\s*=\s*(["']?)(?:file:|cid:)[^"'\s>]*\1/i, `src="${dataUri}"`) : '';
    });
}

export function readAsDataUri(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export function dataUriToBlob(dataUri) {
    const [header, data] = dataUri.split(',');
    const type = header.replace(/^data:|;base64$/g, '');
    const binary = atob(data);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], {type});
}
